/**
 * Login page with Cognito authentication.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useAuth } from '../contexts/AuthContext';

export function LoginPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading while checking auth status
  if (isLoading) {
    return null; // Or a loading spinner
  }

  // If authenticated, don't render (will redirect)
  if (isAuthenticated) {
    return null;
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Exelizer
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
            Portfolio Intelligence & Risk Management
          </Typography>
          <Authenticator
            loginMechanisms={['email']}
            signUpAttributes={['email']}
            socialProviders={[]}
          >
            {({ signOut, user }) => (
              <Box>
                <Typography variant="body1" align="center" sx={{ mb: 2 }}>
                  Welcome, {user?.signInDetails?.loginId || 'User'}!
                </Typography>
                <Box display="flex" justifyContent="center" gap={2}>
                  <Button variant="contained" onClick={() => navigate('/')}>
                    Go to Dashboard
                  </Button>
                  <Button variant="outlined" onClick={signOut}>
                    Sign Out
                  </Button>
                </Box>
              </Box>
            )}
          </Authenticator>
        </Paper>
      </Box>
    </Container>
  );
}
